import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=4f3e458e&scoped=true"
import script from "./DepositModal.vue?vue&type=script&lang=js"
export * from "./DepositModal.vue?vue&type=script&lang=js"
import style0 from "./DepositModal.vue?vue&type=style&index=0&id=4f3e458e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e458e",
  null
  
)

export default component.exports